import { useLocation } from 'react-router-dom';
import { useRef, useEffect } from 'react';

const getBasePath = (pathname: string) => pathname.split('/')[1] || '';

const useRestoreScroll = (): boolean => {
  const { pathname } = useLocation();
  const currentBasePath = getBasePath(pathname);
  const prevBasePathRef = useRef<string>(currentBasePath);

  const shouldRestore = currentBasePath !== prevBasePathRef.current;

  useEffect(() => {
    prevBasePathRef.current = currentBasePath;
  }, [currentBasePath]);

  return shouldRestore;
};

export default useRestoreScroll;
